<div class="dropdown">
  <button type="button" class="dropdown-trigger" (click)="toggleOpen()">
    <div class="chips" *ngIf="selected.length; else placeholderTpl">
      <span class="chip" *ngFor="let item of selected">
        {{ item }}
        <span class="chip-remove" (click)="removeChip(item, $event)">&times;</span>
      </span>
    </div>
    <ng-template #placeholderTpl>
      <span class="placeholder">{{ placeholder }}</span>
    </ng-template>
    <span class="dropdown-arrow" [class.open]="open">▾</span>
  </button>

  <div class="dropdown-panel" *ngIf="open">
    <input
      class="filter-input"
      type="text"
      [(ngModel)]="filter"
      placeholder="Search…"
      (click)="$event.stopPropagation()"
    />
    <div class="options-list">
      <label class="option-item" *ngFor="let opt of filteredOptions">
        <input type="checkbox" [checked]="isSelected(opt)" (change)="toggleOption(opt)" />
        <span>{{ opt }}</span>
      </label>
      <div class="empty-hint" *ngIf="filteredOptions.length === 0">No matches</div>
    </div>
    <div class="panel-footer">
      <button type="button" class="clear-btn" (click)="clearAll($event)" [disabled]="selected.length === 0">
        Clear all
      </button>
      <span class="count-label">{{ selected.length }} selected</span>
    </div>
  </div>
</div>
